module.exports = __webpack_public_path__ + "static/05-caseStudies@2x-03a05845e8b2525ba4ce74ddc87e9590.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/05-caseStudies@2x.png
// module id = 2645
// module chunks = 35783957827783